import React from 'react';
import Container from "../../components/container/container-component";
import Filters from "../filters/filters-container";

const DevComponent = (
  {
    filtersToSend
  }
) => {
  return (
    <Container>
      <div style={{
        width: '20%',
        backgroundColor: 'white'
      }}>
        <Filters/>
      </div>
      <div
        style={{
          width: '80%',
          backgroundColor: 'white'
        }}
      >
        <pre
          style={{
            fontSize: '14px'
          }}
        >
        {
          JSON.stringify(filtersToSend, null, 2)
        }
        </pre>
      </div>

    </Container>
  )
};


export default DevComponent;


// WEBPACK FOOTER //
// ./src/modules/dev/dev-component.js